const MEDIA_UUID_RE =
	/[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;
const API_MEDIA_ID_RE =
	/\/api\/media\/([0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})(?:\b|[/?#])/i;
const MEDIA_SCHEME_RE =
	/^media:([0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i;

/** File Manager id from a bare UUID, `media:` scheme, or `/api/media/{id}` URL. */
export function mediaIdFromReference(
	value: string | null | undefined
): string | null {
	if (typeof value !== "string") {
		return null;
	}
	const trimmed = value.trim();
	if (!trimmed) {
		return null;
	}
	const byApi = trimmed.match(API_MEDIA_ID_RE);
	if (byApi?.[1]) {
		return byApi[1].toLowerCase();
	}
	const byScheme = trimmed.match(MEDIA_SCHEME_RE);
	if (byScheme?.[1]) {
		return byScheme[1].toLowerCase();
	}
	if (MEDIA_UUID_RE.test(trimmed) && !trimmed.includes("/")) {
		const direct = trimmed.match(MEDIA_UUID_RE);
		return direct?.[0]?.toLowerCase() ?? null;
	}
	return null;
}
